import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { th } from "date-fns/locale";
import dayjs from "dayjs";

interface RangeDateFilterProps {
  onStartDateChange: (date: string) => void;
  onEndDateChange: (date: string) => void;
}

const RangeDateFilter: React.FC<RangeDateFilterProps> = ({
  onStartDateChange,
  onEndDateChange,
}) => {
  // ตั้งค่าเริ่มต้นเป็นวันที่ 1 ของเดือนปัจจุบัน
  const [startDate, setStartDate] = useState<Date | null>(
    dayjs().startOf("month").toDate()
  );
  // ตั้งค่าเริ่มต้นเป็นวันปัจจุบัน
  const [endDate, setEndDate] = useState<Date | null>(dayjs().toDate());

  const handleStartDateChange = (date: Date | null) => {
    console.log("RangeDateFilter - Start date selected:", date);
    setStartDate(date);
    if (onStartDateChange && date) {
      // แปลงวันที่เป็นรูปแบบ ISO (yyyy-MM-dd)
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const isoDate = `${year}-${month}-${day}`;
      console.log("RangeDateFilter - ISO start date:", isoDate);
      onStartDateChange(isoDate);
    }
  };

  const handleEndDateChange = (date: Date | null) => {
    console.log("RangeDateFilter - End date selected:", date);
    setEndDate(date);
    if (onEndDateChange && date) {
      // แปลงวันที่เป็นรูปแบบ ISO (yyyy-MM-dd)
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const isoDate = `${year}-${month}-${day}`;
      
      console.log("RangeDateFilter - ISO end date:", isoDate);
      onEndDateChange(isoDate);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={th}>
      <Box sx={{ display: "flex", gap: 2 }}>
        <Box sx={{ width: { xs: "50%", md: 200, lg: "auto" } }}>
          <Typography
            variant="body2"
            sx={{
              mb: 1,
              fontWeight: 500,
              color: "#333",
            }}
          >
            วันที่เริ่มต้น
          </Typography>
          <DatePicker value={startDate} onChange={handleStartDateChange} />
        </Box>
        <Box sx={{ width: { xs: "50%", md: 200, lg: "auto" } }}>
          <Typography
            variant="body2"
            sx={{
              mb: 1,
              fontWeight: 500,
              color: "#333",
            }}
          >
            วันที่สิ้นสุด
          </Typography>
          <DatePicker value={endDate} onChange={handleEndDateChange} />
        </Box>
      </Box>
    </LocalizationProvider>
  );
};

export default RangeDateFilter;
